import { render } from "./CreatePaymentRecord.vue?vue&type=template&id=602c35c1&scoped=true"
import script from "./CreatePaymentRecord.vue?vue&type=script&lang=js"
export * from "./CreatePaymentRecord.vue?vue&type=script&lang=js"

import "./CreatePaymentRecord.vue?vue&type=style&index=0&id=602c35c1&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602c35c1"]])

export default __exports__